<template>
    <sessions-store
        v-slot="{
            sid,
            error,
            is_loading,
            has_loaded,
            store
        }"
        @success="onSuccess"
    >
        <sessions-create-form
            :sid="sid"
            :is-saving="is_loading || has_loaded"
            @submit="store(_.extend(arguments[0], {
                intended: $route.query.intended
            }))"
        >
            <template v-slot:modals>
                <error-modal
                    v-if="error && $error.is(error, { exclude: [400, 422] })"
                    :error="error"
                />
            </template>
        </sessions-create-form>
    </sessions-store>
</template>

<script>
    import HeadMixin from '../../../mixins/head'
    import SessionsCreateForm from '../../../components/sessions-create-form'
    import SessionsStore from '../../../components/sessions-store'

    export default {
        mixins: [
            HeadMixin
        ],
        components: {
            SessionsCreateForm,
            SessionsStore
        },
        methods: {
            head () {
                return {
                    title: 'Login'
                }
            },
            onSuccess ({ meta }) {
                window.location = meta.redirect_to || this.$laroute.route('dashboard.index')
            }
        }
    }
</script>
